import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import IVehicleBrand from '../interfaces/IVehicleBrand';
import Layout from '~/components/Layout';

export default function Create() {     
  const {register, handleSubmit, control, setValue:setFormValue} = useForm<IVehicleBrand>();
  const fields = [
      { name: 'name', type: 'string'},
  ];
  
    return(
      <Layout marginLayout={true}>
        <CrudCreate model={'vehicle-brand'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        messageSuccess={'Vehicle brand successfully created!'}  
        title={'Add vehicle brand'}  
        subheader={'Add vehicle brand'}
        setFormValue={setFormValue} />
      </Layout>
    )
}
